import { ApiClient } from '../../http/api_client';

export class SearchItemRepository {
  async sendRequest(searchParameter: string) {
    return ApiClient.get(
      `/ksearch/?${searchParameter}`
    );
  }
}
